import type { ReactNode } from 'react';
import styled from 'styled-components';

export const WhyGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  margin-top: 52px;

  @media ${({ theme }) => theme.media.desktop} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const WhyItem = styled.div<{ children?: ReactNode }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  background: white;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const WhyEmoji = styled.div`
  font-size: 2.5rem;
  margin-bottom: 16px;
`;

export const WhyItemTitle = styled.h3`
  font-size: 1.25rem;
  color: #2d3436;
  margin-bottom: 12px;
`;

export const WhyItemDescription = styled.p`
  color: #636e72;
  line-height: 1.6;
  text-align: center;
`;
